export default {
  title: 'Widget Settings',
  minValue: 'Minimum threshold',
  maxValue: 'Max Threshold',
  submit: 'Apply',
  cancel: 'Cancel',
}